module.exports = __webpack_public_path__ + "img/icon-room-kitchen.bbc15f80.svg";